<footer class="footer footer-layout">
    <div class="container">
        <div class="row col-md-12">
          <div class="desktop-footer-links">
            <a href="https://www.cap.org/contact-and-support">Contact & Support</a> | 
            <a href="https://www.cap.org/system-requirements">System Requirements</a> |
            <a href="https://www.cap.org/terms-and-conditions">Terms & Conditions</a> |
            <a href="https://www.cap.org/privacy-policy">Privacy Policy</a>
          </div>
          <div class="mobile-footer-links">
            <a href="https://www.cap.org/contact-and-support">Contact & Support</a>
            <a href="https://www.cap.org/system-requirements">System Requirements</a>
            <a href="https://www.cap.org/terms-and-conditions">Terms & Conditions</a>
            <a href="https://www.cap.org/privacy-policy">Privacy Policy</a>
          </div>
        </div>
        <div class="row col-md-12">
          <span>© {{date.getFullYear()}} College of American Pathologists. All rights reserved.</span>
        </div>
    </div>  
</footer>
